(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fluff-shop-all"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fluff-shop-all')) {
  customElements.define('fluff-shop-all', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.tilt !== 'true') return;
      this.controller = new AbortController();
      const media = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
      this.cards = [...this.querySelectorAll('[data-shop-tilt]')];
      const clear = card => { card.style.removeProperty('--tilt-x'); card.style.removeProperty('--tilt-y'); };
      const options = { signal: this.controller.signal };
      for (const card of this.cards) {
        let bounds;
        card.addEventListener('pointerenter', () => { bounds = card.getBoundingClientRect(); }, options);
        card.addEventListener('pointermove', event => {
          if (!media.matches || !bounds) return;
          const x = Math.max(-.5, Math.min(.5, (event.clientX - bounds.left) / bounds.width - .5));
          const y = Math.max(-.5, Math.min(.5, (event.clientY - bounds.top) / bounds.height - .5));
          card.style.setProperty('--tilt-x', `${-y * 7}deg`);
          card.style.setProperty('--tilt-y', `${x * 7}deg`);
        }, options);
        card.addEventListener('pointerleave', () => { bounds = null; clear(card); }, options);
      }
      media.addEventListener('change', () => this.cards.forEach(clear), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
